"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var styled_components_1 = __importDefault(require("styled-components"));
var variants = {
    default: function () { return ""; },
    bordered: function (_a) {
        var bold = _a.bold, color = _a.color;
        return "\n    background-color: white !important;\n    border: solid " + (bold ? 2 : 1) + "px " + color + ";\n    color: " + color + ";\n  ";
    },
};
var StyledComponentTag = styled_components_1.default(antd_1.Tag)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    ", "\n    ", "\n  }\n"], ["\n  &&& {\n    ", "\n    ",
    "\n  }\n"])), function (_a) {
    var bold = _a.bold;
    return (bold ? "font-weight: bold;" : "");
}, function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? "default" : _b, color = _a.color, bold = _a.bold;
    return variants[variant]({ color: color, bold: bold });
});
var StyledTag = function (_a) {
    var children = _a.children, color = _a.color, _b = _a.bold, bold = _b === void 0 ? false : _b, _c = _a.variant, variant = _c === void 0 ? "default" : _c, rest = __rest(_a, ["children", "color", "bold", "variant"]);
    return (react_1.default.createElement(StyledComponentTag, __assign({}, rest, { color: color, bold: bold, variant: variant }), children));
};
exports.default = StyledTag;
var templateObject_1;
